import React, { FC, useContext } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import {
  DecisionUploadFormLabel,
  DecisionUploadFormError,
} from '../components/DecisionUploadFormComponents';
import { DecisionUploadContext } from '../../DecisionUploadContext';

type Props = {
  value: string;
  hasError: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const DecisionUploadJuridictionField: FC<Props> = ({
  value,
  hasError,
  onChange,
}) => {
  const { jurisdictions } = useContext(DecisionUploadContext);
  return (
    <>
      <DecisionUploadFormLabel htmlFor="upload-jurisdiction">
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadJuridictionField.tsx/1" />
      </DecisionUploadFormLabel>
      <select
        id="upload-jurisdiction"
        value={value}
        className={classNames(hasError && 'is-invalid-input')}
        name="juridiction"
        onChange={onChange}
      >
        <option value="" aria-label="Empty option" />
        {jurisdictions &&
          Object.keys(jurisdictions).map(juridictionKey => (
            <option key={juridictionKey} value={juridictionKey}>
              {jurisdictions[juridictionKey].name}
            </option>
          ))}
      </select>
      {hasError && (
        <DecisionUploadFormError>
          <FormattedMessage id="upload/decision-upload/components/DecisionUploadJuridictionField.tsx/2" />
        </DecisionUploadFormError>
      )}
    </>
  );
};
